import { ApiError } from '../api/client'
import { stampErrorText } from '../attendance/stampError'
import { formatHMS } from './format'
import { useOrderTime } from './useOrderTime'
import { useWorkTimer } from './useWorkTimer'

/** Arbeits-Timer + gebuchte Gesamtzeit eines Auftrags. Eingebettet im Auftrags-Detail. */
export function OrderTimer({ orderId }: { orderId: number }) {
  const timer = useWorkTimer(orderId)
  const time = useOrderTime(orderId)
  const total = time.data?.totalSeconds ?? 0

  return (
    <section className="timer" aria-label="Zeiterfassung">
      <div className="timer-total">
        Gebuchte Zeit: <strong>{formatHMS(total)}</strong>
      </div>

      {timer.busyOtherOrderId ? (
        <p className="muted" role="status">
          Ein Timer läuft bereits für Auftrag #{timer.busyOtherOrderId}. Erst dort stoppen.
        </p>
      ) : timer.running ? (
        <div className="timer-run">
          <span className="timer-live" role="timer" aria-label="laufende Zeit">
            {formatHMS(timer.elapsed)}
          </span>
          <button type="button" className="btn stop" onClick={timer.stop} disabled={timer.submitting}>
            Stopp &amp; buchen
          </button>
        </div>
      ) : timer.attBlocked ? (
        <>
          <button type="button" className="btn start" onClick={timer.startWithStamp} disabled={timer.stamping}>
            {timer.attBlocked === 'pause' ? 'Pause beenden & starten' : 'Einstempeln & starten'}
          </button>
          <p className="muted" role="status">
            {timer.attBlocked === 'pause' ? 'Du bist in der Pause' : 'Du bist nicht eingestempelt'} — Auftragszeit
            zählt nur während gestempelter Arbeitszeit.
          </p>
          {timer.stampError ? (
            <p className="error" role="alert">
              Einstempeln fehlgeschlagen: {stampErrorText(timer.stampError)}
            </p>
          ) : null}
        </>
      ) : (
        <button type="button" className="btn start" onClick={timer.start}>
          Zeit starten
        </button>
      )}

      {timer.lastResult === 'queued' ? (
        <p className="warn" role="status">
          Zeit gesichert – wird automatisch nachgebucht, sobald die Verbindung steht.
        </p>
      ) : null}
      {timer.error ? (
        <p className="error" role="alert">
          Zeit konnte nicht gebucht werden: {timer.error instanceof ApiError ? timer.error.message : 'Fehler'}.
        </p>
      ) : null}
    </section>
  )
}
